<template>
  <el-dialog
    :title="title"
    :visible.sync="value"
    :close-on-click-modal="closeOnClickModal"
    :width="width"
    @close="onClose"
  >
    <el-table v-loading="loading" :data="list" style="width: 100%">
      <el-table-column v-for="(item, index) in columns" :key="index" align="center" v-bind="item">
        <template v-if="item.children">
          <el-table-column
            v-for="(sub, key) in item.children"
            :key="key"
            align="center"
            v-bind="sub"
          >
            <template #default="subScope">
              <div v-if="sub.vslot">
                <slot
                  :name="sub.vslot"
                  :row="subScope.row"
                  :col="sub"
                  :rowIndex="subScope.$index"
                  :colIndex="index + key"
                ></slot>
              </div>
              <div v-else-if="sub.formatter">{{ sub.formatter(subScope.row, sub) }}</div>
              <div v-else>{{ defaultCell(subScope.row[sub.prop]) }}</div>
            </template>
          </el-table-column>
        </template>
        <template #default="scope">
          <div v-if="item.vslot">
            <slot
              :name="item.vslot"
              :row="scope.row"
              :col="item"
              :rowIndex="scope.$index"
              :colIndex="index"
            ></slot>
          </div>
          <div v-else-if="item.formatter">{{ item.formatter(scope.row, item) }}</div>
          <div v-else>{{ defaultCell(scope.row[item.prop]) }}</div>
        </template>
      </el-table-column>
    </el-table>

    <div slot="footer" class="dialog-footer">
      <el-button @click="onClose" type="primary">{{ okText }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'BikeTableDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '标题',
    },
    width: {
      type: String,
      default: '50%',
    },
    columns: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      default: () => [],
    },
    okText: {
      type: String,
      default: '关闭',
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    cellPlaceholder: {
      type: String,
      default: '-',
    },
  },

  watch: {
    value(v) {
      if (v) {
        this.onShow()
      }
    },
  },

  data() {
    return {
      loading: false,
    }
  },

  methods: {
    onShow() {
      this.$emit('show', this.getArgs())
    },

    onClose() {
      this.list.splice(0, this.list.length)
      this.loading = false
      this.$emit('input', false)
    },

    getArgs() {
      return { start: this.start.bind(this), done: this.done.bind(this) }
    },

    start() {
      this.loading = true
    },

    done(close) {
      this.loding = false
      if (close) {
        this.onClose()
      }
    },
    defaultCell(value) {
      if (value === undefined || value === null || value === '') return this.cellPlaceholder
      return value
    },
  },
}
</script>
